import { Avenant } from "@/types";
import { deleteData, getData, postData, putData } from "./axios-service";

function modelMapper(inputAvenant: any): Avenant {
    return {
        id: inputAvenant.id,
        nbLaveLinge: inputAvenant.nbLaveLinge,
        nbSecheLinge: inputAvenant.nbSecheLinge,
        nbLaveLingeChauffant: inputAvenant.nbLaveLingeChauffant,
        nbLintTrap: inputAvenant.nbLintTrap,
        nbCondensateur: inputAvenant.nbCondensateur,
        nbArmoireLessive: inputAvenant.nbArmoireLessive,
        nbPompeLessive: inputAvenant.nbPompeLessive,
        nbStackedLave: inputAvenant.nbStackedLave,
        nbStackedSeche: inputAvenant.nbStackedSeche,
        nbCentrale: inputAvenant.nbCentrale,
        nbMonnayeur: inputAvenant.nbMonnayeur,
        nbBallonEauChaude: inputAvenant.nbBallonEauChaude,
        tarifLavage: inputAvenant.tarifLavage,
        tarifSechage: inputAvenant.tarifSechage,
        tarifLessive: inputAvenant.tarifLessive,
        dureeDuContrat: inputAvenant.dureeDuContrat,
        dateDeDemarrage: inputAvenant.dateDeDemarrage,
        laverieId: inputAvenant.laverieId,
        observation: inputAvenant.observation
    };
}

export function modelMapperArray(inputArray: any[]): Avenant[] {
    return inputArray.map(modelMapper);
}

export async function getAvenantsByLaverie(laverieId: string): Promise<Avenant[]> {
    const avenants = await getData<Avenant[]>("/laveries/" + laverieId + "/avenants");
    return modelMapperArray(avenants ?? []);
}

export function getAvenantById(avenantId: string): Promise<Avenant> {
    return getData("/avenants/" + avenantId).then(
        onSucceed => {
            return modelMapper(onSucceed);
        }
    );
}

export function postAvenant(avenant: Avenant, laverieId: number | string): Promise<Avenant> {
    return postData("/laveries/" + laverieId + "/avenants", avenant).then(
        onSucceed => {
            return modelMapper(onSucceed);
        }
    );
}

export function putAvenant(avenant: Avenant): Promise<any> {
    return putData("/avenants/" + avenant.id, avenant)
}

export function deleteAvenant(avenantId: string): Promise<any> {
    return deleteData("/avenants/" + avenantId)
}